import { ChangeDetectorRef, Component, OnInit, EventEmitter } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DataService, ISendNotificationOfCreatedEvent } from 'src/app/services/data.service';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { IEvent } from 'src/app/shared/models/event';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/services/auth.service';
import { CompressImageService } from 'src/app/services/compress-image.service';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { googleMapsLinkValidator } from 'src/app/shared/utils/configuration';
import { GeminiService } from 'src/app/services/gemini.service';

export interface TableElement {
  fullName: string;
  description: string;
  categories: string[];
  startDateOfEvent: string;
  dueDateOfEvent: string;
  createdAt: string;
  availableReservation: boolean;
  locationName: string;
  likeCount: number;
  priceRange: string;
  image?: string;
}

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent implements OnInit {

  displayedColumns: string[] = [
    'fullName',
    'description',
    'categories',
    'startDateOfEvent',
    'dueDateOfEvent',
    'createdAt',
    'availableReservation',
    'isOffer',
    'locationName',
    'likeCount',
    'priceRange',
    'saved',
    'shared',
    'feedback',
    // 'reservationsCount',
    'clicks',
    'wantToReserve'
  ];

  loading = true;
  
  event: IEvent;
  
  state = 'list';
  
  data: IEvent[] = [
  ];
  sortedData: IEvent[];
  selectedEvent: IEvent | null = null; // Track selected event
  isEditing: boolean = false; // Control form visibility
  isMobile: boolean = false;

  columnsToDisplay: string[] = this.displayedColumns.slice();

  private $imageCompressed = new EventEmitter();
  private subs = new Subscription();
  public imageUrl: any;

  sendNotification = false;

  monthNotifications = 0;

  newNotificationForm: FormGroup;
  notificationSent = false;

  constructor(private breakpointObserver: BreakpointObserver, 
    private fb: FormBuilder,
    private changes: ChangeDetectorRef,
    private _snackBar: MatSnackBar,
    private compressService: CompressImageService,
    public authService: AuthService,
    public geminiService: GeminiService,
    public dataService: DataService) {
      this.newNotificationForm = this.fb.group({
        title: ['', Validators.required]
      })

  }

  async ngOnInit() {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isMobile = result.matches;
    });
    this.setUp();
  }

  async setUp() {
    if (!this.authService.userData.brandId) {
      this.authService.signOut();
    } else { 
      this.data = await this.dataService.getEventsFromUser(this.authService.userData.brandId);
      this.data = [...this.data];
      this.sortedData = this.data.slice();

      this.loading = false;

    }

    const monthNotifications = await this.dataService.getNotificationsCountForCurrentMonth(this.authService.userData.brandId);
  
    this.loading = false;
    this.dataService.monthNotifications = Math.abs(monthNotifications - this.authService.userData.notificationsPerMonth);

  }

  createEvent() {
    this.state = 'create';
    this.isEditing = true;
  }

  async selectEvent(event: IEvent) {
    this.state = 'view';
    this.selectedEvent = { ...event }; // Store the selected event
    this.notificationSent = await this.dataService.eventHasNotificationSent(event);
    this.isEditing = true; // Show the editable form/card

    this.imageUrl = event.image;

  }

  cancelEdit() {
    this.state = 'list';
    this.selectedEvent = null; // Clear selected event
    this.isEditing = false; // Hide the form/card
  }

  getCategoryName(id: string) {
    const category = this.dataService.categories.filter((cat: any) =>  cat.categoryId === id)[0];
    return category.name;
  }

  checkToSendNotification(check: boolean) {
    this.sendNotification = check
  }

  sortData(sort: any) {
    const data = this.data.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a:any, b: any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'fullName': return compare(a.fullName, b.fullName, isAsc);
        case 'startDateOfEvent': return compare(a.startDateOfEvent, b.startDateOfEvent, isAsc);
        case 'dueDateOfEvent': return compare(a.dueDateOfEvent, b.dueDateOfEvent, isAsc);
        case 'createdAt': return compare(a.createdAt, b.createdAt, isAsc);
        case 'availableReservation': return compare(a.availableReservation, b.availableReservation, isAsc);
        case 'locationName': return compare(a.locationName, b.locationName, isAsc);
        case 'likeCount': return compare(a.likeCount, b.likeCount, isAsc);
        case 'priceRange': return compare(a.priceRange, b.priceRange, isAsc);
        case 'clicks': return compare(a.clicks, b.clicks, isAsc);
        case 'feedback': return compare(a.feedback, b.feedback, isAsc);
        case 'isOffer': return compare(a.isOffer, b.isOffer, isAsc);
        case 'wantToReserve': return compare(a.wantToReserve, b.wantToReserve, isAsc);
        case 'shared': return compare(a.shared, b.shared, isAsc);
        case 'saved': return compare(a.saved, b.saved, isAsc);
        default: return 0;
      }
    });
  }

  edit(event: IEvent) {    
    this.state = 'edit';
    this.isEditing = true;
  }

  eventSaved(updatedEvent: any) {
    this.selectedEvent = null;
    this.state = 'list';
    this.setUp();
  }

  sendNotificationForSelecetedEvent() {

    this.loading = true;
    const obj: ISendNotificationOfCreatedEvent = {
      user: this.authService.userData,
      notificationTitle: this.newNotificationForm.controls.title.value,
      event: this.selectedEvent
    }

    this.dataService.sendNotificationOfCreatedEvent(obj).then((res)=>{
      this._snackBar.open('Notificación eviada a todos tus seguidores :)', 'OK', {
        duration: 3000
      })
      this.newNotificationForm.reset();
      this.notificationSent = true;
      this.sendNotification = false;
      this.loading = false;
    }).catch((err)=>{
      this._snackBar.open('Error al mandar la notificacion', 'OK', {
        duration: 3000
      })
    });
  }
  createGift() {
    this.state = 'gift';
    this.isEditing = true;
  }
}
function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}